/**
 * Hook truy cập dialog đăng nhập từ AuthDialogContext.
 */
import { useContext } from 'react';
import { AuthDialogContext } from '../context/AuthDialogContext';

/**
 * @returns {{ isOpen: boolean, openLoginDialog: Function, closeLoginDialog: Function }}
 */
export const useLoginDialog = () => {
  const context = useContext(AuthDialogContext);

  if (!context) {
    throw new Error('useLoginDialog must be used within AuthDialogProvider');
  }

  return {
    isOpen: context.isLoginOpen,
    openLoginDialog: context.openLoginDialog,
    closeLoginDialog: context.closeLoginDialog,
  };
};
